import type { ReactNode } from 'react';

import { api } from '../../api';
import { Painel, data } from '../../comum';
import { baixarJson } from '../Configuracoes';
import type { RespostaConfig } from '../../tipos';
import type { PropsSecao } from './comum';

/**
 * O bundle que o suporte pede.
 *
 * Ambiente fechado não tem dashboard remoto: quando algo quebra, este arquivo
 * é a única evidência que atravessa a fronteira do cliente.
 */
export function SecaoDiagnostico({
  c,
  acao,
  boot,
}: PropsSecao & {
  readonly boot: RespostaConfig['boot'];
}): ReactNode {
  return (
    <Painel
      titulo="Diagnóstico"
      sub="Ambiente fechado não tem dashboard remoto. Quando algo quebrar, o suporte pede este arquivo."
    >
      <p className="suave">
        Instalação{' '}
        {c.instalacao.concluida
          ? `concluída em ${data(c.instalacao.concluidaEm)} por ${c.instalacao.concluidaPor ?? '—'}`
          : 'não concluída'}
        . Porta {boot.porta} · dados em <span className="mono">{boot.caminhoDados}</span> · chave
        mestra vinda {boot.origemDaChaveMestra === 'ambiente' ? 'do ambiente' : 'de arquivo'}.
      </p>
      <button
        disabled={acao.executando}
        onClick={() =>
          void acao.rodar(async () => {
            const d = await api.get<Record<string, unknown>>('/api/config/diagnostico');
            baixarJson(d, `diagnostico-${new Date().toISOString().slice(0, 10)}.json`);
            return 'Diagnóstico baixado.';
          })
        }
      >
        Baixar bundle de diagnóstico
      </button>
    </Painel>
  );
}
